<template>
  <div>
    <v-app-bar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>{{appTitle}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span class="caption">{{version}}</span>
    </v-app-bar>

    <div id="dragAndDropWrapper" :style="{width: '100%', height: dragAreaHeight + 'px'}">
      <div v-if="isValidBrowser">
      <div v-show="!isProcessing"
        :style="{
          backgroundColor: this.isFileDragging ? '#fff1f1' : '',
          borderColor: this.isFileDragging ? 'red' : '',
        }"
        @dragenter.prevent="onDragEnter"
        @dragover.prevent="onDragOver"
        @dragleave.prevent="onDragLeave"
        @dragend.prevent="onDragEnd"
        @drop.prevent="onDrop" id="dragAndDropArea" >
        <div>ここに成績のExcelファイルをドロップ</div>
        <div>または</div>
        <v-btn
          :loading="false"
          :disabled="false"
          color="blue-grey"
          class="white--text"
          @click="openFileDialog"
        >
      ファイルを選択
        </v-btn>
        <!-- https://stackoverflow.com/questions/52645358/vuetify-file-uploads -->
        <input id="dummyInput" ref="dummyInput" type="file" accept=".xlsx" style="display:none" @change="onFileChange"/>
      </div>
      <div v-show="isProcessing">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      </div>
      <div v-if="!isValidBrowser" :style="{textAlign: 'center'}">
        <p>お使いのブラウザではご利用になれません</p>
        <p>Edge/Chrome/Safari/Firefoxの最新バージョンでご利用ください</p>
      </div>
    </div>
    

    <v-row justify="center">
      <!-- <v-dialog v-model="areaDialog" scrollable max-width="300px" persistent> -->
      <v-dialog v-model="areaDialog" scrollable max-width="300px" persistent>
        <v-card data-cy="area-card">
          <v-card-title>領域を選択してください</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 480px;">
            <v-radio-group v-model="areaDialogValue" column>
              <v-radio v-for="item in ryoikis" :key="item.label" :label="item.label" :value="item.value" :data-cy="item.label"></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-center">
            <v-btn :disabled="!this.areaDialogValue" color="blue darken-1" text @click="onSelectArea" data-cy="submit-area">決定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


  </div>
</template>

<script>
import Promise from 'bluebird'
import * as R from 'ramda'
import { 
  file2ArrayBuffer, 
  arrayBuffer2Binary, 
  binary2Xlsx,
  getCellValueInSheet,
  getRowsLength,
  } from '@/services/xlsx.js'
import { getMyCources } from '@/services/specjson.js'
import { mapState, mapMutations } from 'vuex';
import myWorker from '@/worker'
import { VERSION, APP_TITLE } from '@/const'
import Bowser from "bowser"
import { setupSpecList } from '@/services/specjson.js'
const specJson = require('../../spec/spec' + process.env.VUE_APP_YEAR + '.json');
const consola = require('consola')
export default {
  name: 'nedb',
  data () {
    return {
      g: null, // generator
      dbkakunin: [],
      // MEMO: rは、Y11などで検索した科目を、どこに割り当てたかを保持するツリー
      r: {},
      generatorDone: true,
      totalCredit: 0,
      totalFreeCredit: 0,
      totalMustCredit: 0,
      totalSelectCredit: 0,
      dragAreaHeight: 0,
      isProcessing: false,
      student: {
        name: '',
        number: ''
      },
      isFileDragging: false,
      version: '',
      isValidBrowser: true,
      appTitle: APP_TITLE,
      isConsolaActive: null,

      // ---

      ryoikis2018: [
        { label: '美術史', value: { spec: 'Y11', label: '美術史' }},
        { label: '芸術支援', value: { spec: 'Y12', label: '芸術支援' }},
        { label: '洋画', value: { spec: 'Y21', label: '洋画' }},
        { label: '日本画', value: { spec: 'Y24', label: '日本画' }},
        { label: '彫塑', value: { spec: 'Y22', label: '彫塑' }},
        { label: '書', value: { spec: 'Y23', label: '書' }},
        { label: '版画', value: { spec: 'Y25', label: '版画' }},

        { label: '構成', value: { spec: 'Y6', label: '構成' }},
        { label: '総合造形', value: { spec: 'Y6', label: '総合造形' }},
        { label: '工芸', value: { spec: 'Y6', label: '工芸' }},
        { label: 'ビジュアルデザイン', value: { spec: 'Y6', label: 'ビジュアルデザイン' }},

        { label: '情報・プロダクトデザイン', value: { spec: 'Y7', label: '情報・プロダクトデザイン' }},
        { label: '環境デザイン', value: { spec: 'Y7', label: '環境デザイン' }},
        { label: '建築デザイン', value: { spec: 'Y7', label: '建築デザイン' }},
      ],
      ryoikis2019: [
        { label: '美術史', value: { spec: 'YBA', label: '美術史' }},
        { label: '芸術支援', value: { spec: 'YBB', label: '芸術支援' }},
        { label: '洋画', value: { spec: 'YBC', label: '洋画' }},
        { label: '日本画', value: { spec: 'YBE', label: '日本画' }},
        { label: '彫塑', value: { spec: 'YBF', label: '彫塑' }},
        { label: '書', value: { spec: 'YBG', label: '書' }},
        { label: '版画', value: { spec: 'YBD', label: '版画' }},

        { label: '構成', value: { spec: 'YBK', label: '構成' }},
        { label: '総合造形', value: { spec: 'YBJ', label: '総合造形' }},
        { label: '工芸', value: { spec: 'YBH', label: '工芸' }},
        { label: 'ビジュアルデザイン', value: { spec: 'YBL', label: 'ビジュアルデザイン' }},

        { label: '情報・プロダクトデザイン', value: { spec: 'YBN', label: '情報・プロダクトデザイン' }},
        { label: '環境デザイン', value: { spec: 'YBP', label: '環境デザイン' }},
        { label: '建築デザイン', value: { spec: 'YBQ', label: '建築デザイン' }},
      ],

      areaDialogValue: null,
      areaDialog: false,
    }
  },
  watch: {
    isConsolaActive (val) {
      if (val) {
        consola.resumeLogs()
      } else {
        consola.pauseLogs()
      }
    }
  },
  computed: {
    ...mapState([
      'csvReplaceTable',
      'specsList',
      'courceLabels',
      'senmon',
      'ignoreStudents'
    ]),
    ryoikis () {
      return process.env.VUE_APP_YEAR === '2018' ? this.ryoikis2018 : this.ryoikis2019
    }
  },
  methods: {
    ...mapMutations([
      'updateResultJson',
      'updateSpecsList',
      'updateJudgeDFList',
      'updateRemainList',
      'updateSenmon'
    ]),
    async resetData () {

      this.updateSpecsList({
        specsList: setupSpecList(specJson)
      })

      this.g = null,
      this.dbkakunin = []
      this.r = {}
      this.generatorDone = true
      this.totalCredit = 0
      this.totalFreeCredit = 0
      this.totalMustCredit = 0
      this.totalSelectCredit = 0
      this.dragAreaHeight = 0
      this.isProcessing = false
      this.student = {name: '', number: ''}
      this.isFileDragging = false
      // this.version
      // this.isValidBrowser
      // this.appT
      await this.$xlsxdb.removeAsync({}, {multi: true})
    },
    onDragEnter () { this.isFileDragging = true },
    onDragOver () { this.isFileDragging = true },
    onDragLeave () { this.isFileDragging = false },
    onDragEnd () { this.isFileDragging = false },
    async showDB () {
      // var r = await this.$xlsxdb.findAsync({})
      var r = await this.$xlsxdb.findAsync({使用済み: {$ne: true}})
      // var r = await this.$xlsxdb.findAsync({使用済み: true})
      for(let i = 0;i<r.length;i++){
        this.dbkakunin.push(r[i])
      }
    },
    openFileDialog () {
      this.$refs.dummyInput.click()
    },
    onFileChange (e) {
      let files = e.target.files || e.dataTransfer.files
      // MEMO: ファイルダイアログからは１つしかこない
      if (files.length === 1) {
        this.onDrop2(files[0])
      } else {
        window.alert('ファイル選択エラー')
      }
    },
    async onDrop (e) {
      if (e.shiftKey) {
        this.isConsolaActive = true
      }
      e.preventDefault()
      if (e.dataTransfer.files.length > 1) {
        this.cancelDrop()
        window.alert('複数のファイルがドロップされました')
        return false
      }
      const filename = e.dataTransfer.files[0].name
      const ext = R.pipe(R.split('.'), R.last)(filename)
      if (ext !== 'xlsx') {
        window.alert('xlsxファイルをドロップしてください')
        this.cancelDrop()
        return false
      }
      const file = e.dataTransfer.files[0]
      this.onDrop2(file)
    },
    cancelDrop () {
      this.isFileDragging = false
    },
    async onDrop2 (file) {
      const arrayBuffer = await file2ArrayBuffer(file)
      const binary = await arrayBuffer2Binary(arrayBuffer)
      const xlsxFile = await binary2Xlsx(binary)
      const curried = R.curry(getCellValueInSheet)
      const sheetName = R.pipe(R.keys,R.head)(xlsxFile.Sheets)
      const getCellValue = curried(xlsxFile.Sheets[sheetName])
      const rowsLength = getRowsLength(xlsxFile.Sheets[sheetName])
      const columns = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K']
      let headerRecord
      try {
        headerRecord = R.pipe(
          R.map(columnName => getCellValue({ column: columnName, row: 1})),
          R.map(R.trim)
        )(columns)
      } catch (e) {
        // MEMO: jpgファイルの拡張子をxlsxにしてもここを通ります
        window.alert('不正なExcelファイルです')
        this.cancelDrop()
        return
      }
      // debugger
      const dataRecords = R.map(rowNumber => {
        const formatter = {
          2: value => String(value), // 科目番号
          4: value => Number(value), // 単位数
          9: value => Number(value) // 開講年度
        }
        return R.pipe(
          R.map(columnName => getCellValue({ column: columnName, row: rowNumber})),
          // R.tap(v => console.log('v', v)), 
          R.evolve(formatter),
          // R.tap(v => console.log('v', v)), 
        )(columns)
      }, R.times(n => n + 2, rowsLength - 1))
      var earnedCredits = R.map(record => R.zipObj(headerRecord, record), dataRecords)

      // MEMO: 空行は学籍番号のundefinedで判定
      const excelEmptyRowFilter = o => !R.isNil(o.学籍番号)
      earnedCredits = R.filter(excelEmptyRowFilter, earnedCredits)

      var schoolYear = Number(earnedCredits[0].学籍番号.substr(0,4))
      
      //
      if (process.env.VUE_APP_YEAR === '2018') {
        if (schoolYear < 2016 || schoolYear > 2018) {
          window.alert(`判定対象外のデータです
このプログラムは2016年度〜2018年度入学者が対象です。`)
          this.cancelDrop()
          return
        }
      } else if (process.env.VUE_APP_YEAR === '2019') {
        // 2019
        if (schoolYear < 2019) {
          window.alert(`判定対象外のデータです
このプログラムは2019年以降度入学者が対象です。`)
          this.cancelDrop()
          return
        }
      }
      

      //MEMO: ここにignoreListに含まれている学生がいたら止める
      if (R.includes(Number(earnedCredits[0].学籍番号), this.ignoreStudents)) {
        window.alert(`Japan-Expert 日本芸術はこのプログラムでは判定できません。支援室にご相談ください。`)
        this.cancelDrop()
        return
      }

      const dfFilter = o => R.includes(o.総合評価, ['D', 'F'])
      const ignoreDfFilter = o => !R.includes(o.総合評価, ['D', 'F'])

      // DとF評価のリスト
      var dfCredits = R.filter(dfFilter, earnedCredits)
      this.updateJudgeDFList({list: dfCredits})
      // 最初からDとFは作業オブジェクトから削除しておく
      earnedCredits = R.filter(ignoreDfFilter, earnedCredits)

      // ここでearnedCreditsを上から順に見ていって、置き換え対象の科目番号だった場合(2019)、パターンによって処理する
      // 例 パターン1 新しいのを入れる。自分は新しいのに関連づけてから消す
      // 例 パターン2 新しいのを二つ入れる。自分のはそれぞれに関連づける どちらか片方を「計算済みフラグ」をたてる
      // 例 パターン3 新しいのをいずれかにおきかえる まだ履修していないフラグ
      // 例 パターン4 1と同じ
      const replaceCredit = (credit) => {
        credit.使用済み = false
        var replaceInfo = R.find(R.propEq('新科目番号', credit.科目番号))(this.csvReplaceTable)
        if (replaceInfo) {
          const tmp = R.clone(credit)
          const replaceKeys = ['科目番号', '単位数', '科目名']
          const pickedReplaceInfo1 = R.zipObj(replaceKeys,R.props(['旧科目番号1', '単位数', '2018年度以前科目名1'], replaceInfo))
          const pickedReplaceInfo2 = R.zipObj(replaceKeys,R.props(['旧科目番号2', '単位数', '2018年度以前科目名2'], replaceInfo))
          switch(replaceInfo.パターン) {
            case 1:
              credit = R.mergeRight(credit, pickedReplaceInfo1)
              credit.original = tmp
            break;
            case 2:
              var credit2 = R.clone(credit)
              // 旧A
              credit = R.mergeRight(credit, pickedReplaceInfo1)
              credit.original = tmp
              // MEMO: 旧B でもどうせあまる = 今の所結果に表示されない 結果に表示させるとしたら別の方法を考える
              credit2 = R.mergeRight(credit, pickedReplaceInfo2)
              credit2 = R.mergeRight(credit2, {使用済み: true, original: tmp})
              earnedCredits.push(credit2)
            break;
            case 3:
              // MEMO: まだ履修中 o.総合評価=履修中？
              credit = R.mergeRight(credit, pickedReplaceInfo1)
              credit = R.mergeRight(credit, {総合評価: '履修中', original: tmp})
              // 
            break;
            default: 
              throw new Error('パターンが不正です')
          }
        } else {
          // consola.pauseLogs()
          consola.info('置き換えなし')
        }

        return credit
      }
      if (process.env.VUE_APP_YEAR === '2018') {
        // 2018までは置き換えるが
        earnedCredits = R.map(replaceCredit, earnedCredits)
      } else {
        // 2019は置き換えしないかわりに、2018の置き換え内で行ってる使用済みの初期値をセットしておく
        earnedCredits = R.map(credit => {
          return R.assoc('使用済み', false, credit)
        },earnedCredits)
      }
      this.student.name = earnedCredits[0].学生氏名
      this.student.number = earnedCredits[0].学籍番号
      // debugger
      // dbに格納
      await this.$xlsxdb.insertAsync(earnedCredits)

      // MEMO: 卒業研究番号
      var senmonRecord = await this.$xlsxdb.findAsync({科目名: '卒業研究'})
      var sotsukenKamokuNumber = R.path([0, '科目番号'], senmonRecord)
      if (sotsukenKamokuNumber) {
        
        var myCources = getMyCources(sotsukenKamokuNumber)
        // -------
        const keys = R.keys(this.courceLabels)
        let resultLabel = ''
        let resultKey = ''
        for( let i = 0; i < keys.length; i++ ){
          if (sotsukenKamokuNumber.indexOf(keys[i]) === 0) {
            resultLabel = this.courceLabels[keys[i]]
            resultKey = keys[i]
          }
        }
        this.updateSenmon({senmon: {key: resultKey, label: resultLabel}})
        //-------

        this.removeOtherCourceFromSpec(myCources)
      } else {
        // window.alert('専攻を判断するための卒業研究が取得できませんでした')
        // throw new Error('専攻を判断するための卒業研究が取得できませんでした')
        this.areaDialog = true
      }

    },
    // MEMO: 卒業研究が見つからなかった場合に領域が選択されたときの処理
    onSelectArea () {
      // window.alert(this.areaDialogValue.label + ',' +  this.areaDialogValue.spec)
      const { label: resultLabel, spec: resultKey } = this.areaDialogValue
      this.updateSenmon({senmon: {key: resultKey, label: resultLabel}})
      var myCources = [resultKey, 'special', 'basic']
      this.removeOtherCourceFromSpec(myCources)
      this.areaDialog = false;

    },
    // MEMO: myCources = ['Y6', 'special', 'basic']
    removeOtherCourceFromSpec (myCources) {
      // MEMO: 自分の卒業研究から取得したコース以外を specから外す      
      var slist = []
      for(let i = 0; i < this.specsList.length; i++) {
        let courceName = this.specsList[i].cource
        if (R.includes(courceName, myCources)) {
          slist.push(this.specsList[i])
        }
      }

      // #55自由選択科目を後回し
      const s = R.clone(slist)
      // slist = [s[0], s[1], s[3], s[4], s[6], s[7], s[2], s[5], s[8]] //# 55
      slist = [s[6], s[0], s[3], s[7], s[1], s[4], s[8], s[2], s[5]] // #81

      // MEMO: speclistを更新
      this.updateSpecsList({
        specsList: slist
      })

      this.onPressGenerator()
    },

    onPressGenerator () {
      // console.log(this.g)
      if (this.generatorDone) {
        // 開始時にリセット
        this.totalCredit = 0
        this.totalFreeCredit = 0
        this.totalMustCredit = 0
        this.totalSelectCredit = 0
      }
      this.isProcessing = true
      this.gnext()
    },
    async gnext () {
      const { value: generatorValue, done } = this.g.next()

      this.generatorDone = done

      if (done) {
        // 単位トータル
        this.writeToRTotal()
        // student
        this.writeToRStudent()
        // 点数だけでなく最小単位の判定を全て洗う
        this.writeToSmallestUnitPass()
        // speclistのカテゴリごと最低点を満たしているか これがNGだと総合得点がOKでもNG
        this.writeSpecListAllCategoryPassed()

        this.updateResultJson({ resultJson: this.r})

        // D/F以外でどこにも当てはまらなかったのを確認
        var amari = await this.$xlsxdb.findAsync({ 
          使用済み: false, 
          $and: [
            {総合評価: {$ne: 'D'}},
            {総合評価: {$ne: 'F'}}
          ] 
        })
        consola.info('あまり', amari)
        this.updateRemainList({ list: amari})
        
        this.isProcessing = false
        this.$router.push('result')
        return
      } else {
        if (R.pathEq(['status'], 'loopStart')(generatorValue)) {
          consola.log('---START---')
          let { limit, cource, requiredType } = generatorValue.spec
          consola.log('🌺🌺🌺',cource, requiredType, limit[0], limit[1])
          // MEMO: 選択の上限を上回らないように
          this.groupLimit = limit[1]
          this.sum = 0
          this.realSum = 0
        } else if (R.pathEq(['status'], 'loopProgress')(generatorValue)) {
          const { condition: { conditions, limit, label }, parentSpec} = generatorValue
          consola.log('この番号を探す>>', conditions.toString())
          consola.log('🍎小計リミットは',label, limit[0], limit[1])

          //sum計算----------------------------------------------------------------
          var findResultSum = 0
          var concatCources = [] // [{cource}, {cource}]
          for(let i = 0; i < conditions.length; i++) {
            var head = conditions[i]
            var reg = new RegExp("^" + head);
            // const findResult = await this.$xlsxdb.findAsync({科目番号: reg, 使用済み: {$ne: true}, $and: [{総合評価: {$ne: 'D'}}, {総合評価: {$ne: 'F'}}]}) // すでに使用されているのを除外
            const findResult = await this.$xlsxdb.findAsync({科目番号: reg, 使用済み: {$ne: true}}) // すでに使用されているのを除外
            // console.log(findResult)
            concatCources.push(...findResult)
            findResultSum += R.pipe(R.project(['単位数']),R.pluck('単位数'),R.sum)(findResult)
          }
          //sum計算ここまで----------------------------------------------------------------
          const { requiredType } = R.pick(['requiredType'],parentSpec)
          var creditsCombinations = []

          if ( limit[0] > findResultSum) {
            consola.log('🍎🍏🍏🍏🍏🍏🍏単位たりない', R.pick(['cource', 'requiredType'],parentSpec), label)
            consola.log('🍎🍏🍏🍏🍏🍏🍏いくつたりないかというと', limit[0] - findResultSum)
            creditsCombinations = R.pipe(R.project(['単位数']), R.pluck('単位数'))(concatCources)
            // MEMO: 合計しても足りないのでここはR.sum(creditsCombinations)に蓋をする必要なし
            this.sum += limit[0]
            // this.sum += R.sum(creditsCombinations)
            this.realSum += R.sum(creditsCombinations)
            // debugger
          } else if (limit[0] <= findResultSum && findResultSum <= limit[1]) {
            // クリアしている かつ かつ上限以下
            consola.log('🍎🍎🍎🍎🍏🍏🍏単位範囲内でたりた', R.pick(['cource', 'requiredType'],parentSpec), label)
            consola.log('🍊🍊🍊🍊🍊🍊', this.sum, this.groupLimit)

            // MEMO: 選択科目のみ、自由科目に回すための計算が必要
            if (requiredType === 'select') {
              const targetGroupLimit = this.groupLimit - this.sum

              if (targetGroupLimit >= findResultSum) {
                // MEMO: グループの上限に達しない場合はいままでと計算が同じ
                creditsCombinations = R.pipe(R.project(['単位数']), R.pluck('単位数'))(concatCources)
                this.sum += R.sum(creditsCombinations)
                this.realSum += R.sum(creditsCombinations)
              } else {
                // MEMO: グループの上限を超えてしまう場合は、超えないように組み合わせを計算
                const targetLimit = Math.min(findResultSum, targetGroupLimit)
                let creditsCombinationString = await myWorker.getCombination({arr: R.pluck('単位数')(concatCources), target: targetLimit, option: 'over', isConsoleActive: this.isConsolaActive})
                consola.log('🍏', creditsCombinationString)
                consola.log('🍏', R.pick(['cource', 'requiredType'],parentSpec))
                const o = JSON.parse(creditsCombinationString)
                creditsCombinations = o.result ? o.result : []
                consola.log('🍏',creditsCombinations)
                consola.log('🍏',R.sum(creditsCombinations))
                consola.log('🎽', targetLimit)
                if (R.sum(creditsCombinations) > targetLimit) {
                  consola.log('🥎組み合わせ計算がlimitより大きくなった')
                }
                this.sum += R.min(R.sum(creditsCombinations), targetLimit)
                this.realSum += R.min(R.sum(creditsCombinations), targetLimit)
                consola.log('🍑', '+' + R.min(R.sum(creditsCombinations), targetLimit) + '=' +this.sum)
              }
            } else {
              // MEMO: 必修科目と自由科目はもともとのロジック
              creditsCombinations = R.pipe(R.project(['単位数']), R.pluck('単位数'))(concatCources)
              this.sum += R.sum(creditsCombinations)
              this.realSum += R.sum(creditsCombinations)
            }
          } else {
            // 超えている
            consola.log('🍏🍏🍏🍏🍏🍏🍏🍎🍎単位が上限を超えている', R.pick(['cource', 'requiredType'],parentSpec), label, findResultSum)
            consola.log('🍊🍊🍊🍊🍊🍊', this.sum, this.groupLimit)
            let targetGroupLimit = this.groupLimit - this.sum
            consola.log('🍓',targetGroupLimit)
            // debugger
            let targetLimit;
            switch (requiredType) {
              case 'must':
                targetLimit = limit[0]
              break;
              case 'select':
                // MEMO: selectは上限に設定 余った単位はfreeへ
                targetLimit = Math.min(limit[1], targetGroupLimit)
                // debugger
              break;
              case 'free':
                // MEMO: freeは上限まで適用
                // debugger
                targetLimit = limit[1]
              break;
            }
            // MEMO: getCombinationは、targetに指定した組み合わせがない場合、それに満たない一番近いのを返してくる
            // console.log('a', R.pluck('単位数')(concatCources).join(','))
            // console.log('b', concatCources)
            var creditsCombinationString = await myWorker.getCombination({arr: R.pluck('単位数')(concatCources), target: targetLimit, option: 'over', isConsoleActive: this.isConsolaActive})
            // console.log('b')
            consola.log('🍏', creditsCombinationString)
            consola.log('🍏', R.pick(['cource', 'requiredType'],parentSpec))
            var o = JSON.parse(creditsCombinationString)
            creditsCombinations = o.result ? o.result : []
            consola.log('🍏',creditsCombinations)
            consola.log('🍏',R.sum(creditsCombinations))
            if (R.sum(creditsCombinations) > targetLimit) {
              consola.log('🥎組み合わせ計算がlimitより大きくなった')
            }
            // MEMO: targetLimitで蓋をする
            this.sum += R.min(R.sum(creditsCombinations), targetLimit)
            this.realSum += R.min(R.sum(creditsCombinations), targetLimit)
            consola.log('🐳追加する時これを超えてはいけない',targetLimit)
            consola.log('🍑', '+' + R.min(R.sum(creditsCombinations), targetLimit) + '=' +this.sum)
          }
          // MEMO: 
          // var tmpConcatCources = R.clone(concatCources)
          var assignCources = []
          for (let filterCounter = 0; filterCounter < creditsCombinations.length; filterCounter ++ ) {
            let courceIndex = R.findIndex(R.propEq('単位数', creditsCombinations[filterCounter]))(concatCources)
            if (courceIndex > -1) {
              assignCources.push(R.clone(concatCources[courceIndex]))
              concatCources = R.remove(courceIndex, 1, concatCources)
            }
          }
          const aConditionCreditsSum = R.pipe(R.project(['単位数']), R.pluck('単位数'), R.sum)(assignCources)
          // debugger
          await Promise.mapSeries(
            assignCources, 
            (cource) => new Promise(async (resolve) => {
              // MEMO nedb updateは{multi: true}にしないと複数updateされない
              // MEMO 科目番号を置き換えたため、一つの科目番号が２つ以上存在する場合がある。このため使用済みかどうかで判断し、一つだけ処理する
              let numUpdate = await this.$xlsxdb.updateAsync({科目番号: cource.科目番号, 使用済み: false}, {$set: { 使用済み: true }}, {})
              if (numUpdate > 1) {
                throw new Error('レコードが複数更新されました')
              }
              this.writeToR({cource, label, limit, parentSpec, credit: aConditionCreditsSum })
              resolve()
             }
          ))
          // MEMO: assignCourcesが0のときは上のpromise.mapSeriesが動かないのでこちらで補う
          if(assignCources.length === 0) {
            this.writeToR({cource: {}, label, limit, parentSpec, credit: 0})
          }
        } else if (R.pathEq(['status'], 'loopEnd')(generatorValue)) { 
          let { cource: parentCourceName, requiredType, limit } = generatorValue.spec
          let resultInfo = {
            // passed: this.sum >= limit[0],
            passed: this.realSum >= limit[0],
            limit,
            // credit: this.sum
            credit: this.realSum
          }
          this.writeToRResultInfo({parentCourceName, requiredType, resultInfo})

          // this.totalCredit += this.sum
          this.totalCredit += this.realSum

          switch (requiredType) {
            case 'free':
              this.totalFreeCredit += this.realSum
              break;
            case 'select':
              this.totalSelectCredit += this.realSum
              break;
            case 'must':
              this.totalMustCredit += this.realSum
              break
          }
        }
        this.generatorAutoNext()
      }
    },
    writeToRTotal () {
      var basePath = ['total']
      this.r = R.set(R.lensPath(basePath), {
        free: this.totalFreeCredit,
        select: this.totalSelectCredit,
        must: this.totalMustCredit,
        total: this.totalCredit
        }, this.r)
    },
    writeToRStudent () {
      var basePath = ['student']
      const { name = '', number } = this.student
      this.r = R.set(R.lensPath(basePath), { name, number }, this.r)
    },
    // rの中身の個別の合否を見る
    writeToSmallestUnitPass () {

      const senmonKey = this.senmon.key

      const free1Lens = R.lensPath(['credits', senmonKey, 'free', 'cources'])
      const free2Lens = R.lensPath(['credits', 'basic', 'free', 'cources'])
      const free3Lens = R.lensPath(['credits', 'special', 'free', 'cources'])

      const select1Lens = R.lensPath(['credits', senmonKey, 'select', 'cources'])
      const select2Lens = R.lensPath(['credits', 'basic', 'select', 'cources'])
      const select3Lens = R.lensPath(['credits', 'special', 'select', 'cources'])

      const must1Lens = R.lensPath(['credits', senmonKey, 'must', 'cources'])
      const must2Lens = R.lensPath(['credits', 'basic', 'must', 'cources'])
      const must3Lens = R.lensPath(['credits', 'special', 'must', 'cources'])

      // 最小項目の得点をチェック
      const checkSmallestUnitPassed = (lens) => {
        const c = R.view(lens, this.r)
        const ke = R.keys(c)
        return R.all(cource => cource.resultInfo.passed)(R.props(ke,c));
      }

      const equalsTrue = R.equals(true);
      const freeResult = R.all(equalsTrue)([
        checkSmallestUnitPassed(free1Lens),
        checkSmallestUnitPassed(free2Lens),
        checkSmallestUnitPassed(free3Lens)
      ]);

      const mustSelectResult = R.all(equalsTrue)([
        checkSmallestUnitPassed(select1Lens),
        checkSmallestUnitPassed(select2Lens),
        checkSmallestUnitPassed(select3Lens),
        checkSmallestUnitPassed(must1Lens),
        checkSmallestUnitPassed(must2Lens),
        checkSmallestUnitPassed(must3Lens)
      ])

      this.r = R.set(R.lensPath(['smallestUnitPassed']), {freeResult, mustSelectResult}, this.r)
    },
    // #81
    writeSpecListAllCategoryPassed () {
      const senmonKey = this.senmon.key
      const passedList = R.map(n => {
        let lens = R.lensPath(R.concat(R.concat(['credits'], n), ['resultInfo', 'passed']))
        let passed = R.view(lens, this.r)
        return passed
      }, R.xprod([senmonKey, 'special', 'basic'], ['must', 'select', 'free']))
      let isPassed = R.all(R.equals(true), passedList)
      this.r = R.set(R.lensPath(['categoryAllPassed']), isPassed , this.r)
    },

    writeToRResultInfo ({parentCourceName, requiredType, resultInfo}) {
      var basePath = ['credits', parentCourceName, requiredType]
      this.r = R.over(R.lensPath(basePath), R.merge(R.__, {resultInfo}), this.r)
    },
    writeToR ({cource, label, limit, parentSpec, credit}) {
      const { cource: parentCourceName, requiredType, limit: parentLimit} = parentSpec
      // var basePath = [parentCourceName, requiredType]
      var basePath = ['credits', parentCourceName, requiredType]
      var childPath = R.concat(basePath, ['cources', label])
      var courcePath = R.concat(childPath, ['credits'])
      const parentLens = R.lensPath(basePath)
      const childLens = R.lensPath(childPath)
      const courceLens = R.lensPath(courcePath)
      
      if (R.isNil(R.view(parentLens, this.r))) {
        this.r = R.set(parentLens, {info: {limit: parentLimit}}, this.r)
      }      
      
      var addCource = R.isEmpty(cource) ? [] : [cource]
      if (R.isNil(R.view(childLens, this.r))) {
        let resultInfo = {
          passed: credit >= limit[0],
          limit,
          credit
        }
        this.r = R.set(childLens, {credits: addCource, resultInfo}, this.r)
      } else {
        this.r = R.over(courceLens, R.concat(R.__, addCource), this.r)
      }
    },
    generatorAutoNext () {
      // MEMO: 自動ループ 一つずつ確認したいときはコメント化
      this.gnext()
    },
  },
  async created () {
    this.isConsolaActive = false
    await this.resetData()

    this.version = VERSION

    const browser = Bowser.getParser(window.navigator.userAgent);
    this.isValidBrowser = browser.satisfies({
      safari: '>12.0',
      chrome: '>72',
      firefox: '>65',
      'Microsoft Edge': '>18'
    })
  },
  mounted () {
    document.title = APP_TITLE
    Array.prototype.gForEach = function* (fn) {
      for (let i = 0; i < this.length; i ++) {
        yield* fn(this[i], i, this)
      }
    }

    this.sepcGenerator = function* () {
      yield* this.specsList.gForEach(function*(spec) {
        yield {status: 'loopStart', spec} // {conditions, cource, limit, requiredType}
        yield* spec.conditions.gForEach(function*(condition) {
          yield { status: 'loopProgress', condition, parentSpec: spec }
        })
        yield {status: 'loopEnd', spec}
      })
    }

    this.g = this.sepcGenerator()

    window.onresize = (event) => {
      this.dragAreaHeight = event.target.innerHeight
    }
    this.dragAreaHeight = window.innerHeight
  }
}
</script>

<style>
#dragAndDropWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: azure */
}
#dragAndDropArea {
  width: 400px;
  height: 300px;
  /* line-height: 300px; */
  /* background-color:bisque; */
  border-width: 1;
  border-color: lightgray;
  border-style: dashed;
  border-radius: 10px;
  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;
  /* justify-content: space-around; */
  align-items: center; /* align vertical */
}
.bg{
    background: gray;
    color: #fff;
    font-size: 18px;
}
</style>
